import CRUD from "@/firebase/crud";
import store from "@/store/index";
import filter from "lodash-es/filter";
import find from "lodash-es/find";


const integration = {
    namespaced: true,
    state:  {
        fsAPIKey: "", // Filestack API Key
        fsReadPolicy: "", // Filestack Read Policy
        fsReadSignature: "", // Filestack Read Signature
        fsUploadPolicy: "", // Filestack Upload Policy
        fsUploadSignature: "" // Filestack Upload Signature
    },
    mutations: {
        setValue(state, [name, data]) {
            state[name] = data;
        }
    },
    actions: {
        readIntegrations: async ({ commit }) => {
            try {
              let Collection = "integrations";
              let portalID = store.state.portal.active.id;
              let Mutation = "integration/setValue";
              store.commit(Mutation, []);
              let Result = Promise.resolve(
                CRUD.ReadDocuments(Collection, portalID, null)
              );
              Result.then(Response => {
                switch (Response.result) {
                  case "success":
                    var Data = filter(Response.data, { enabled: true });
                    var fsAPIKey = find(Data, {integrationName: "fsapikey"})
                    if (fsAPIKey !== {}) {
                        store.commit(Mutation, ["fsAPIKey", fsAPIKey.integrationValue]);
                    }
                    var fsReadPolicy = find(Data, {integrationName: "fsreadpolicy"})
                    if (fsReadPolicy !== {}) {
                        store.commit(Mutation, ["fsReadPolicy", fsReadPolicy.integrationValue]);
                    }
                    var fsReadSignature = find(Data, {integrationName: "fsreadsignature"})
                    if (fsReadSignature !== {}) {
                        store.commit(Mutation, ["fsReadSignature", fsReadSignature.integrationValue]);
                    }
                    var fsUploadPolicy = find(Data, {integrationName: "fsuploadpolicy"})
                    if (fsUploadPolicy !== {}) {
                        store.commit(Mutation, ["fsUploadPolicy", fsUploadPolicy.integrationValue]);
                    }
                    var fsUploadSignature = find(Data, {integrationName: "fsuploadsignature"})
                    if (fsUploadSignature !== {}) {
                        store.commit(Mutation, ["fsUploadSignature", fsUploadSignature.integrationValue]);
                    }
                    break;
                  case "failure":
                    //do nothing
                    break;
                  case "error":
                    //do nothing
                    break;
                  default:
                    //do nothing
                    break;
                }
              });
            } catch (err) {
              // console.log("store/modules/integration.js >> Error = " + err);
            }
        },
    }
}

export default integration;